module.exports = __webpack_public_path__ + "static/media/phone@2x.e09076a0.png";